import BaseController from "controllers/backend/base"
import CreateTenderWidget from "widgets/backend/createTenderWidget"
import {default as jQuery} from 'jquery';
import applyLocalTimeZone from "servos/applyLocalTimeZone";

class Controller extends BaseController {
  call() {
    super.call()
    applyLocalTimeZone.call(this)
    bindResultsFilter.call(this)
    bindCheckAllCheckbox.call(this)
    createTender.call(this)
    addVehicle.call(this)
    removeVehicleList.call(this)
    observerVehicleChanges.call(this)
  }
};

var bindResultsFilter = function() {
  let elem = this.root
  this.resultsFilter = new CreateTenderWidget(elem)
}

var observerVehicleChanges= function() {
  MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  var observer = new MutationObserver(function(mutations, observer) {
    var v = $('.selected-tender-vehicle-list')
    for (var i=0, n = v.length; i < n; i++) {
      $('input[type="checkbox"][id="'+$(v[i]).attr('id')+'"]').prop("checked", true)
    }
    if($('input[type="checkbox"].select-vehicle').length==$('input[type="checkbox"]:checked.select-vehicle').length){
      $('#check_all_group').prop("checked", true)
    }

  });
  observer.observe(this.root.find('.data-results')[0], {
    childList: true
  });
}

var buttonStatus = function() {
  const vehicleOnList = $('.selected-tender-vehicle-list')

  if (vehicleOnList.length > 0) {
    document.querySelector("input[id=create-tender]").disabled = false
  } else {
    document.querySelector("input[id=create-tender]").disabled = true
  }
}

var bindCheckAllCheckbox = function() {
  this.root.on('#check_all_group').on("click", (e) => {
    if (e.target.name === 'check_all_group') {
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      const selectAll = document.querySelector('#check_all_group').checked;
      const vehicleOnList = $('.selected-tender-vehicle-list')
      let nameOfVehicle = [];
      let listOfVehicle = [];

      for (var i=0, n = checkboxes.length; i < n; i++) {
        checkboxes[i].checked = document.querySelector('#check_all_group').checked;
      }
      let in_tender = $('.selected-tender-vehicle-list').map(function() {return this.id;})
      if (selectAll) {
        for (var i=1, n = checkboxes.length; i < n; i++) {
          if($.inArray(checkboxes[i].id,in_tender)==-1) {
            listOfVehicle.push(checkboxes[i].id)
            nameOfVehicle.push(checkboxes[i].className.replace("select-vehicle ", ""))
          }
        }
      } else {
        for (var i=1, n = checkboxes.length; i < n; i++) {
          $('.selected-tender-vehicle-list').find("#"+checkboxes[i].id).parent().remove()
        }
        buttonStatus()
      }

      displayVehicleOnList(nameOfVehicle, listOfVehicle)
    }
  })
}

var addVehicle = function() {
  this.root.on("click", ".select-vehicle", (e) => {
    var id = e.target.id
    let nameOfVehicle = [];
    let listOfVehicle = [];
    const selectedVehicle = document.querySelector(`input[id='${id}']`)

    if (selectedVehicle.checked) {
      listOfVehicle.push(selectedVehicle.id)
      nameOfVehicle.push(selectedVehicle.className.replace("select-vehicle ", ""))
    } else {
      var vehicleOnList = document.querySelector(`p[id="${selectedVehicle.id}"]`)
      if (vehicleOnList !== null) {
        $('.selected-tender-vehicle-list').find(`#${id}`).parent().remove()
      }
    }

    displayVehicleOnList(nameOfVehicle, listOfVehicle)
 })
}

var displayVehicleOnList = function(nameOfVehicle, listOfVehicle) {
  var ul = document.createElement('ul')
  nameOfVehicle.map((name, index) => {
    var span = document.createElement('span')
    span.setAttribute('id', listOfVehicle[index])
    span.classList.add('remove-tender-vehicle-list')
    var remove = document.createTextNode('x')
    span.appendChild(remove)

    var li = document.createElement('p')
    li.classList.add('selected-tender-vehicle-list')
    li.setAttribute('id', listOfVehicle[index])
    var vehicle = document.createTextNode(name)
    li.appendChild(span)
    li.appendChild(vehicle)

    ul.appendChild(li)
  })

  document.getElementById("vehicle-list").appendChild(ul);
  buttonStatus()
}

var removeVehicleList = function() {
  this.root.on("click", ".remove-tender-vehicle-list", (e) => {
    var id = event.target.id
    $('.selected-tender-vehicle-list').find(`#${id}`).parent().remove()
    buttonStatus()
 })
}

var createTender = function() {
  this.root.find('#create-tender').on("click", (e) => {
    const country = document.querySelector('.sort-by-country').value
    const tenderName = document.querySelector('input.tender_name').value;
    const tenderStartTime = document.querySelector('input.tender_start_time').value
    const tenderEndTime = document.querySelector('input.tender_end_time').value
    const groups = document.querySelectorAll('.select2-selection__choice');
    const vehicleList = document.querySelectorAll('.selected-tender-vehicle-list');

    let account_selector = document.querySelector('select#tender_account_id')
    let account_id       = undefined

    if (account_selector != undefined) {
      account_id = account_selector.value
    }

    let listOfGroup = [];
    let listOfVehicle = [];

    if (groups != null) {
      for (var i=0, n = groups.length; i < n; i++) {
        listOfGroup.push(groups[i].innerText.substr(1))
      }
    }

    if (vehicleList != null) {
      for (var i=0, n = vehicleList.length; i < n; i++) {
        listOfVehicle.push(vehicleList[i].id)
      }
    }

    fetchBulkAction(country, tenderName, tenderStartTime, tenderEndTime, listOfGroup, listOfVehicle, account_id);
  })
}

var fetchBulkAction = function(country, tenderName, tenderStartTime, tenderEndTime, listOfGroup, listOfVehicle, account_id) {
  $.ajax({
    url: '/backend/tenders.json',
      dataType: 'json',
      method: 'POST',
      data: {
        country: country,
        name: tenderName,
        start_time: tenderStartTime,
        end_time: tenderEndTime,
        groups: listOfGroup,
        vehicles: listOfVehicle,
        account_id: account_id,
        state: 'pending'
      },
      success: function (r) {
        window.location.href = '/backend/tenders'
        console.log('Succeed');
      },
      error: (xhr, text, error) => {
        console.log('Failed');
        swal({
          type: 'error',
          title: 'Failed to create tender.',
          html: xhr.responseJSON.errors
        })
      }
  });
}

export default Controller;
